import React from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import FloorMap from 'components/FloorMapPackage/components/floorMap';
import useFetchGeoJson from 'common/reactHooks/useFetchGeoJson';
import { IState, ITabProperties } from 'appRedux/createStore';
import { FilterTypeEnum, MapTypeEnum, OrderByEnum, TimeFrameValueEnum } from 'common/common';

const FloorMapBackdrop: React.FC = () => {
  const location = useLocation();

  const casinoId = useSelector<IState>(
    (state) => state.app.persistedState.casinoSchema?.kpCasinoPk
  ) as number | undefined;
  const selectedSlots = useSelector<IState>(
    (state) => state.app.persistedState.slotState.selectedSlots
  ) as string[];
  const hottestSlotsFilter = useSelector<IState>(
    (state) => state.app.persistedState.filterState?.[FilterTypeEnum.hottestSlots]
  ) as ITabProperties | undefined;

  const [isFloorMapLoading, setIsFloorMapLoading] = React.useState<boolean>(false);
  const [isMapTransitionLoading, setIsMapTransitionLoading] = React.useState<boolean>(false);
  const { geoJsonData, getGeoJsonLoading, slotMetaData } = useFetchGeoJson(casinoId || 0);

  const selectedHotInsight = hottestSlotsFilter?.insight || 'spins';
  const selectedHotTimeFrame = hottestSlotsFilter?.timeframe || TimeFrameValueEnum.months1;

  const floorMapRefreshKey = React.useMemo(() => {
    return [location.pathname, String(casinoId || ''), selectedHotInsight, selectedHotTimeFrame].join(
      '::'
    );
  }, [location.pathname, casinoId, selectedHotInsight, selectedHotTimeFrame]);

  const isMapRefreshing = isFloorMapLoading || getGeoJsonLoading || isMapTransitionLoading;

  React.useEffect(() => {
    setIsMapTransitionLoading(true);
    const timeoutId = window.setTimeout(() => {
      setIsMapTransitionLoading(false);
    }, 700);

    return () => window.clearTimeout(timeoutId);
  }, [floorMapRefreshKey]);

  return (
    <div className="events-mapstats">
      {isMapRefreshing && (
        <div className="leaderboard-mapstats__loader" role="status" aria-live="polite">
          <span className="leaderboard-table__spinner" aria-hidden="true" />
          <span>Refreshing map...</span>
        </div>
      )}

      {!isMapRefreshing && (
        <FloorMap
          key={floorMapRefreshKey}
          mapId={MapTypeEnum.slotReportMap}
          slotData={[]}
          slotDataIsLoading={isFloorMapLoading}
          sortDirection={OrderByEnum.Asc}
          shouldHideSlotMark={true}
          selectedInsight={selectedHotInsight}
          selectedTimeFrame={selectedHotTimeFrame}
          isShowData={true}
          selectedSlots={selectedSlots}
          geoJsonData={geoJsonData}
          getGeoJsonLoading={getGeoJsonLoading}
          slotMetaData={slotMetaData}
          onClickHeatFilter={() => null}
          onClickSlot={() => null}
          setFloormapLoading={setIsFloorMapLoading}
        />
      )}
    </div>
  );
};

export default FloorMapBackdrop;
